import React from 'react';
import { ExternalLink } from 'lucide-react';
import { Pill, RecPill } from '../aiinterview/recruiter/common';

const List = ({ title, items, testId }) => (items?.length ? (
  <div data-testid={testId}>
    <div className="iv-eyebrow" style={{ margin: '0.6rem 0 0.3rem' }}>{title}</div>
    <ul className="vr-list">{items.map((t) => <li key={t}>{t}</li>)}</ul>
  </div>
) : null);

export default function BriefPanel({ ai, competencies }) {
  return (
    <div className="vr-panel-body" data-testid="brief-panel">
      {ai ? (
        <>
          <div className="iv-row" style={{ justifyContent: 'space-between' }}>
            <div className="iv-row" style={{ gap: '0.5rem' }}>
              <b style={{ fontSize: '1.6rem', fontFamily: 'Cabinet Grotesk, sans-serif', color: '#002A38' }} data-testid="brief-score">{ai.score_100 ?? '—'}</b>
              <span className="iv-small">/100 AI interview</span>
              <RecPill rec={ai.recommendation} testId="brief-rec" />
            </div>
            <a className="iv-btn iv-btn-ghost iv-btn-sm" href={`/ai-interviews/${ai.id}`} target="_blank" rel="noreferrer" data-testid="brief-open-report"><ExternalLink size={14} /> Full report</a>
          </div>
          {ai.summary && <p className="iv-small" style={{ marginTop: '0.6rem' }}>{ai.summary}</p>}
          <List title="Strengths" items={ai.strengths} testId="brief-strengths" />
          <List title="Risks to probe" items={ai.risks} testId="brief-risks" />
          {ai.unverified_claims?.length > 0 && (
            <div data-testid="brief-claims">
              <div className="iv-eyebrow" style={{ margin: '0.6rem 0 0.3rem' }}>Résumé claims to verify</div>
              {ai.unverified_claims.map((c) => <div key={c.claim} className="iv-quote"><Pill tone="amber">{c.status}</Pill> {c.claim}</div>)}
            </div>
          )}
        </>
      ) : <div className="iv-note" data-testid="brief-no-ai">There's no completed AI interview for this candidate on this job, so the copilot works from the job's competencies only.</div>}
      <div>
        <div className="iv-eyebrow" style={{ margin: '0.8rem 0 0.3rem' }}>What this panel assesses</div>
        <div className="iv-row" style={{ gap: '0.35rem' }}>{competencies.map((c) => <Pill key={c.name} tone={c.must_have ? 'navy' : 'slate'}>{c.name}</Pill>)}</div>
      </div>
    </div>
  );
}
